<template>
  <div>
    <b-row class="mt-5">
      <b-col xxs="12" md="8" lg="6" class="mx-auto">
      

        <b-card no-body>

          <div class="row">
            <div class="col p-5">
              <h5 class="font-weight-bold m-0">System Support</h5>
              <h6 class="mb-3 text-muted">{{ appName }}</h6>
            </div>
          </div>

            

          <div class="row no-gutters mb-5">
            <div class="col-6 col-lg-4">
               <b-list-group class="text-black-50" flush>
                <b-list-group-item class=" bg-white">Email</b-list-group-item>
                <b-list-group-item class=" bg-white">Telephone</b-list-group-item>
                <b-list-group-item class=" bg-white">Website</b-list-group-item>
                <b-list-group-item class=" bg-white">Location</b-list-group-item>
              </b-list-group>
            </div>
            <div class="col-6 col-lg-8">
              <b-list-group flush>
                <!-- <b-list-group-item class=" bg-white"> <a href="mailto:zaid26@gmail.com">zaid26@gmail.com</a></b-list-group-item>
                <b-list-group-item class=" bg-white"><a href="tel:+27716097810">(27) 71 609-7810</a></b-list-group-item>
                <b-list-group-item class=" bg-white"><a href="https://niftybit.co.za">niftybit.co.za</a></b-list-group-item>
                <b-list-group-item class=" bg-white"><p class="mb-3">Johannesburg,<br> South Africa</p></b-list-group-item> -->
              </b-list-group>
            </div>
          </div>
         
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME
    };
  }
};
</script>
